/**
 * Subcomponent for the merge accounts checkbox
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

function MergeAccountsCheckbox({ checked, onChange, disabled }) {
  return (
    <div
      style={{
        marginTop: '15px',
        marginBottom: '15px',
        padding: '15px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
      }}
    >
      <label
        htmlFor="merge-accounts-checkbox"
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          fontWeight: 'bold',
          margin: 0,
          fontSize: '14px',
          color: '#856404',
        }}
      >
        <input
          id="merge-accounts-checkbox"
          type="checkbox"
          checked={checked}
          onChange={onChange}
          style={{
            marginRight: '10px',
            width: '18px',
            height: '18px',
            cursor: 'pointer',
          }}
          disabled={disabled}
        />
        <span>
          <FormattedMessage {...messages.mergeAccountsQuestion} />
        </span>
      </label>
    </div>
  );
}

MergeAccountsCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default MergeAccountsCheckbox;
